<!-- EDIT MODE -->
@if (editable) {

  <!-- Header -->
  <div class="flex items-center justify-between mb-6">

    <h2 class="text-lg font-semibold text-gray-900">
      {{ 'CREDIT_SECTION_PARAGRAPH.NARRATIVE' | translate }}
    </h2>

    <button
      type="button"
      (click)="addParagraph()"
      class="section-add-btn"
    >
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      {{ 'CREDIT_SECTION_PARAGRAPH.ADD_PARAGRAPH' | translate }}
    </button>

  </div>

  <!-- Empty State -->
  @if (!activeParagraphs.length) {
    <div class="border border-dashed border-gray-300 rounded-xl py-14 text-center">
      <p class="text-sm text-gray-500">
        {{ 'CREDIT_SECTION_PARAGRAPH.EMPTY_HINT' | translate }}
      </p>
    </div>
  }

  <!-- Paragraph List -->
  @if (activeParagraphs.length) {
    <div
      cdkDropList
      (cdkDropListDropped)="onParagraphDrop($event)"
      class="divide-y divide-gray-100 border border-gray-200 rounded-xl"
    >

      @for (entry of displayParagraphs; track entry.item) {
        <div cdkDrag cdkDragLockAxis="y" class="section-drag-item group bg-white p-5">

          <div class="flex items-center justify-between gap-3 mb-3">

            <div class="flex items-center gap-2">
              <app-section-drag-handle cdkDragHandle></app-section-drag-handle>

              <span class="text-xs font-medium text-gray-400 uppercase tracking-wide">
                {{ 'CREDIT_SECTION_PARAGRAPH.PARAGRAPH_N' | translate: { n: entry.number } }}
              </span>
            </div>

            <button
              type="button"
              (click)="requestRemoveParagraph(entry.index)"
              class="section-delete-btn"
            >
              {{ 'COMMON.DELETE' | translate }}
            </button>

          </div>

          <app-rich-text-editor
            [(ngModel)]="entry.item.content"
            minHeight="120px"
            [placeholder]="'CREDIT_SECTION_PARAGRAPH.CONTENT_PLACEHOLDER' | translate"
          ></app-rich-text-editor>

        </div>
      }

    </div>
  }

  <app-popup
    [(show)]="showDeletePopup"
    title="CREDIT_SECTION_PARAGRAPH.DELETE_PARAGRAPH"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmRemoveParagraph()"
  ></app-popup>

} @else {

  <!-- PREVIEW MODE -->
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-lg font-semibold text-gray-900">
      {{ 'CREDIT_SECTION_PARAGRAPH.NARRATIVE' | translate }}
    </h2>
  </div>

  @if (!activeParagraphs.length) {
    <div class="border border-dashed border-gray-300 rounded-xl py-14 text-center">
      <p class="text-sm text-gray-500">
        {{ 'CREDIT_SECTION.NO_CONTENT_YET' | translate }}
      </p>
    </div>
  }

  @if (activeParagraphs.length) {
    <div class="divide-y divide-gray-100 border border-gray-200 rounded-xl">

      @for (entry of displayParagraphs; track entry.index) {
        <div class="p-5">

          <span class="text-xs font-medium text-gray-400 uppercase tracking-wide">
            {{ 'CREDIT_SECTION_PARAGRAPH.PARAGRAPH_N' | translate: { n: entry.number } }}
          </span>

          <div
            class="rich-text-content mt-2 text-[15px] text-gray-800"
            [innerHTML]="entry.item.content | richText"
          ></div>

        </div>
      }

    </div>
  }

}